export var MixpanelEvents;
(function (MixpanelEvents) {
    // Server
    MixpanelEvents["Login"] = "Login";
    MixpanelEvents["SignUp"] = "SignUp";
    MixpanelEvents["OrganisationConnected"] = "OrganisationConnected";
    MixpanelEvents["OrganisationDisconnected"] = "OrganisationDisconnected";
    MixpanelEvents["TrialStarted"] = "TrialStarted";
    MixpanelEvents["TrialToPaidConversion"] = "TrialToPaidConversion";
    MixpanelEvents["CancelledToPaidConversion"] = "CancelledToPaidConversion";
    MixpanelEvents["TrialExpired"] = "TrialExpired";
    MixpanelEvents["PlanPaidUpfront"] = "PlanPaidUpfront";
    MixpanelEvents["PlanCancelled"] = "PlanCancelled";
    MixpanelEvents["OrganisationLinkedPlan"] = "OrganisationLinkedPlan";
    MixpanelEvents["TestEmailSent"] = "TestEmailSent";
    MixpanelEvents["PinchPaymentEnabled"] = "PinchPaymentEnabled";
    MixpanelEvents["PinchPaymentDisabled"] = "PinchPaymentDisabled";
    MixpanelEvents["PinchPaymentLinkClicked"] = "PinchPaymentLinkClicked";
    MixpanelEvents["SafeModeDisabled"] = "SafeModeDisabled";
    // Client
    MixpanelEvents["AppLoaded"] = "App Loaded";
    MixpanelEvents["PortalLoaded"] = "Portal Loaded";
    MixpanelEvents["InAppDemoCallClicked"] = "In App Demo Call Clicked";
    MixpanelEvents["PortalPageLoaded"] = "Portal Page Loaded";
    MixpanelEvents["PortalInvoiceNotFound"] = "Portal Invoice Not Found";
    MixpanelEvents["PortalInvoiceXeroClicked"] = "Portal Invoice Xero Clicked";
    MixpanelEvents["InAppTourStart"] = "In App Tour Start";
    MixpanelEvents["OnboardingCompleted"] = "Onboarding Completed";
    MixpanelEvents["OnboardingSkipped"] = "Onboarding Skipped";
})(MixpanelEvents || (MixpanelEvents = {}));
export var MixpanelGroupKeys;
(function (MixpanelGroupKeys) {
    MixpanelGroupKeys["OrganisationId"] = "organisation_id";
})(MixpanelGroupKeys || (MixpanelGroupKeys = {}));
//# sourceMappingURL=mixpanel.js.map